import "../../../styles/popupNotificationModal.scss";

import Modal from "./Modal";
import PropTypes from "prop-types";
import React from "react";


export default class AskCopyMyListsModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onNoAction = this.onNoAction.bind(this);
        this.onCopyLists = this.onCopyLists.bind(this);
    }

    onNoAction(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }

        this.props.noAction();
    }

    onCopyLists(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.props.copyLists();
    }

    render() {
        const {
            localization,
            askQuestion,
            deviceType,
            width,    
        } = this.props;
        return (
            
            <Modal onComponentWillUnmount={this.onNoAction} onCloseModal={this.onNoAction}>
                <div className="popup-notification-modal" style={{maxWidth: deviceType==="xs"?width:"500px"}} >
                    <h3>{localization.text("dashboard", "importantMessage")}</h3>
                    <h2>Kopiere mine lister?</h2>
                    <div className="body">
                        { askQuestion.message }
                    </div>
                    <div className="hr"/>
                    <div className="button-wrapper">
                        <button className="btn primary block" onClick={this.onCopyLists}>{localization.text("common", "yes")}</button>
                        <button className="btn primary block" onClick={this.onNoAction}>{localization.text("common", "no")}</button>
                    </div>
                </div>
            </Modal>
        );
    }
}

AskCopyMyListsModal.propTypes = {
    askQuestion: PropTypes.object.isRequired,
    copyLists: PropTypes.func.isRequired,
    noAction: PropTypes.func.isRequired,
    localization: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
};